module.exports = __webpack_public_path__ + "assets/img/Katalog_2025.aa845be6.jpg";